// @ts-nocheck: converted from JS

import ColonyBulkCages from '@/components/Colony/Edit/BulkCages';

export default ColonyBulkCages;
